import React from 'react';
import {Form} from '../../../../stores/Form/Form';
import cx from 'classnames';
import {observer} from 'mobx-react';
import {listTypes} from '../SelectListModal/enum';
import {HTMLForm} from '../HTMLFormEditor/HTMLForm';
import {Form as SubForm} from '../Form';
import {SubFormList} from '../SubformList';
import {SubFormsList} from '../../types';
import styles from '../../styles/screen.module.scss';
import {createDataTestId} from '../../../../utils/dataTestId';

type Props = {
    subForm?: Form;
    isApiLock: () => boolean;
    openSelectListModal: (listType: listTypes) => void;
    runSubForm: (id: string, level: number, isHTMLForm: boolean) => void;
    subFormsList: SubFormsList;
    parentLevel: number;
    disabledSubformList: boolean;
};

export const SubForms = observer(
    ({
        subForm: currentForm,
        isApiLock,
        openSelectListModal,
        runSubForm,
        subFormsList = [],
        parentLevel,
        disabledSubformList
    }: Props) => {
        const childSubForm = currentForm?.activeSubForm;

        if (subFormsList.length === 0 && !currentForm) return null;

        const renderForm = () => {
            const iSHtmlForm = currentForm?.form.Ishtml;
            if (!currentForm) return null;

            return (
                <div className={styles.subformBody}>
                    {iSHtmlForm ? (
                        <HTMLForm
                            isApiLock={isApiLock}
                            readonly={Boolean(currentForm.form.LockBy)}
                            form={currentForm}
                            key={`${currentForm.ename}_${currentForm.parentForm.currentRow}`}
                        />
                    ) : (
                        <SubForm
                            currentForm={currentForm}
                            isApiLock={isApiLock}
                            openSelectListModal={openSelectListModal}
                            isSubForm={true}
                        />
                    )}
                </div>
            );
        };

        const renderChildForm = () => {
            const disabledChildSubFormList = currentForm?.searchModeLevel
                ? true
                : !currentForm?.records[currentForm.currentRow]?.keys;

            return (
                <div className={styles.subformSection}>
                    <SubForms
                        key={currentForm?.ename}
                        disabledSubformList={disabledChildSubFormList}
                        isApiLock={isApiLock}
                        subForm={
                            childSubForm && !childSubForm.isPanelTypeSubform() ? childSubForm : null
                        }
                        subFormsList={currentForm?.subFormsList}
                        runSubForm={runSubForm}
                        parentLevel={currentForm?.level}
                        openSelectListModal={openSelectListModal}
                    />
                </div>
            );
        };

        return (
            <div
                className={styles.sectionIndentX}
                id={currentForm?.id}
                {...createDataTestId('sub-form-wrapper', false)}
            >
                {!!subFormsList.length ? (
                    <SubFormList
                        activeFormId={currentForm?.ename}
                        componentClasses={cx(styles.subFormList, {
                            [styles.subFormListDisabled]: disabledSubformList
                        })}
                        data={subFormsList}
                        openSubForm={runSubForm}
                        level={parentLevel}
                    />
                ) : null}

                {renderForm()}

                {renderChildForm()}
            </div>
        );
    }
);
